import { LoadingButton } from "@mui/lab";
import { Checkbox, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState, memo, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../../../request/Postrequest";
import TimesheetSkeletonLoader from "../../shared/components/TimesheetSkeletonLoader";

import {
  DELETE_TIMESHEET_JOBS,
  FETCH_CLIENT_TIMESHEET_JOBS_AND_ACT_NEW,
  SAVE_CLIENT_TIMESHEETS_NEW,
  SAVE_CLIENT_UD_FIELDS_VALUES,
  FETCH_CLIENT_TIMESHEET_UD_FIELDS_NEW
} from "../../../../constant/Apipath";
import DeletConfirmModal from "../../shared/modals/DeleteConfirmModal";
import { VIEWS } from "./ClockInTimesheetController";
import { ClientEnglishFallback } from "../../../constant/ClientEnglishFallback";
import { BIGrey } from "../../../../assets/helpers";
import { selectionStore, useHasAnySelection, useSelectionMode } from "./stores/selectionStore";

const TIMESHEET_STATUS = {
  IN_REVIEW: "1",
  APPROVED: "2",
  REJECTED: "3",
  IN_PROGRESS: "4"
};

function SelectJobModal({
  setView,
  setTimesheetID,
  timeSheetId,
  setSelectJobData,
  selectJobData,
  setList
}) {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const CLIENT_EMPLOYEE_ID = selectedClientData?.ClientEmployeeId;
  const USER_ID = loginData?.userInformation?.UserId;
  const CLIENT_ID = selectedClientData?.ClientId;
  const CLIENT_COLOR = selectedClientData?.AccentColor || "#000000";
  const TOKEN = loginData?.accessToken;

  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  const [currentDeleteid, setCurrentDeleteid] = useState(0);
  const [confirmModal, setConfirmModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteDataObj, setDeleteDataObj] = useState(null); // to update selectJobData after delete
  
  const [sortByNearby, setSortByNearby] = useState(false);
  const [location, setLocation] = useState({ latitude: 0, longitude: 0 });
  const [jobs, setJobs] = useState([]);

  const {
    TEXT_SORT_BY,
    TEXT_NEAR_BY,
    TEXT_RECENT,
    BUTTON_NEXT,
    TEXT_SELECT_JOB_ACTIVITIES,
    TEXT_GEOLOCATION_NOT_SUPPORTED,
    TEXT_LOCATION_ACCESS_REQUIRED,
    TEXT_UNABLE_TO_ACCESS_LOCATION,
    TEXT_NO_JOBS_FOUND
  } = ClientEnglishFallback?.SelectJobModal(multiLanguageData?.SelectJobModal || {});

  const { TEXT_CANNOT_BE_UNDONE, TEXT_DELETE_HEADER } = ClientEnglishFallback?.ConfirmModal(
    multiLanguageData?.ConfirmModal || {}
  );

  const hasAnySelection = useHasAnySelection();

  // Hydrate committed store when selectJobData changes
  useEffect(() => {
    selectionStore.hydrateCommittedLegacy(selectJobData);
    return () => selectionStore.resetPending();
  }, [selectJobData]);

  useEffect(() => {
    fetchLocation();
    fetchjobsAndActivities();
  }, [sortByNearby]);

  const fetchLocation = async () => {
    if (!navigator.permissions || !navigator.geolocation) return;
    try {
      const permissionStatus = await navigator.permissions.query({ name: "geolocation" });
      if (permissionStatus.state === "granted") {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setLocation({ latitude: position.coords.latitude, longitude: position.coords.longitude });
          },
          (err) => console.warn("fetchLocation-> error", err)
        );
      }
    } catch (err) {
      console.error("fetchLocation-> Error accessing geolocation:", err);
    }
  };

  const fetchjobsAndActivities = async () => {
    setIsLoading(true);
    let userLatitude = 0;
    let userLongitude = 0;
    if (sortByNearby) {
      if (location?.latitude && location?.longitude) {
        userLatitude = location.latitude;
        userLongitude = location.longitude;
      } else {
        if (!navigator.permissions || !navigator.geolocation) {
          alert(TEXT_GEOLOCATION_NOT_SUPPORTED);
          setIsLoading(false);
          return;
        }
        try {
          const permissionStatus = await navigator.permissions.query({ name: "geolocation" });
          if (permissionStatus.state === "denied") {
            alert(TEXT_LOCATION_ACCESS_REQUIRED);
            setIsLoading(false);
            return;
          }
          const position = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject);
          });
          userLatitude = position.coords.latitude;
          userLongitude = position.coords.longitude;
          setLocation({ latitude: userLatitude, longitude: userLongitude });
        } catch (error) {
          alert(TEXT_UNABLE_TO_ACCESS_LOCATION);
          setIsLoading(false);
          return;
        }
      }
    }

    try {
      const payload = {
        PageNumber: 1,
        NrRowsPerPage: 100,
        UserLatitude: userLatitude,
        UserLongitude: userLongitude,
        ClientId: CLIENT_ID,
        ClientEmployeeId: CLIENT_EMPLOYEE_ID,
        SortBy: sortByNearby ? 1 : 2
      };

      const response = await Postrequestcall(FETCH_CLIENT_TIMESHEET_JOBS_AND_ACT_NEW, payload, TOKEN);
      setJobs(response.data.data || []);
    } catch (error) {
      console.log('fetchjobsAndActivities-> Error: ', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handelJobClick = useCallback((job) => {
    const key = `J:${job.clientJobId}`;
    const mode = selectionStore.getMode(key);
    
    if (mode === 'committed') {
      const tsJobId = selectionStore.committed.get(key);
      if (tsJobId) {
        setCurrentDeleteid(tsJobId);
        setConfirmModal(true);
        setDeleteDataObj({ type: 'job', clientJobId: job.clientJobId });
      }
      return;
    }
    selectionStore.toggle(key);
  }, []);

  const handelActivityClick = useCallback((job, activity) => {
    const key = `A:${job.clientJobId}:${activity.id}`;
    const altKey = `A:${activity.id}`;
    const mode = selectionStore.getMode(key, altKey);
    
    if (mode === 'committed') {
      const tsJobId = selectionStore.committed.get(key) || selectionStore.committed.get(altKey);
      if (tsJobId) {
        setCurrentDeleteid(tsJobId);
        setConfirmModal(true);
        setDeleteDataObj({ type: 'act', actid: activity.id, clientJobId: job.clientJobId });
      }
      return;
    }
    selectionStore.toggle(key);
  }, []);

  const handelJobDelete = async () => {
    if (!currentDeleteid) return;
    try {
      setDeleteLoading(true);
      const deleteObj = {
        UserId: USER_ID,
        ReturnRecordId: false,
        ReturnRecordError: true,
        SoftDelete: true,
        DeleteList: [{ Id: currentDeleteid }]
      };
      let res = await Postrequestcall(DELETE_TIMESHEET_JOBS, deleteObj, TOKEN);
      if (res.status === 201) {
        // Update selectionData state to remove the deleted job
        setSelectJobData((prev) => ({
          Act: prev.Act.filter((a) => a.timesheetJobID !== currentDeleteid),
          jobs1: prev.jobs1.filter((a) => a.timesheetJobID !== currentDeleteid)
        }));
        
        // Remove from committed store locally so UI updates instantly
        if (deleteDataObj.type === 'job') {
          selectionStore.removeCommitted(`J:${deleteDataObj.clientJobId}`);
        } else if (deleteDataObj.type === 'act') {
          selectionStore.removeCommitted(`A:${deleteDataObj.clientJobId}:${deleteDataObj.actid}`);
          selectionStore.removeCommitted(`A:${deleteDataObj.actid}`);
        }
      }
    } catch (error) {
      console.log('handelJobDelete-> Error: ', error);
    } finally {
      setConfirmModal(false);
      setDeleteLoading(false);
      setCurrentDeleteid(null);
      setDeleteDataObj(null);
    }
  };

  const formatData = async () => {
    setLoading(true);
    try {
      let currentTimeSheetId = timeSheetId || 0;
      const pendingKeys = selectionStore.getPendingKeys();
      if (pendingKeys.length === 0) {
        setView(VIEWS.LISTING);
        return;
      }

      // Build timeSheetJobList from pending keys
      const timeSheetJobList = [];
      const jobSet = new Set();
      const actSet = new Set();
      
      pendingKeys.forEach(k => {
        if (k.startsWith('J:')) jobSet.add(parseInt(k.split(':')[1]));
        if (k.startsWith('A:')) {
          const parts = k.split(':');
          if (parts.length === 3) {
             actSet.add({ jobId: parseInt(parts[1]), actId: parseInt(parts[2]) });
          }
        }
      });

      jobs.forEach(job => {
        if (jobSet.has(job.clientJobId) && job.clientJobActivitiesList?.length === 0) {
          timeSheetJobList.push({
            Id: 0,
            Notes: "",
            Deleted: false,
            clockInTime: "00:00:00",
            clockOutTime: "00:00:00",
            ClientJobId: job.clientJobId,
            ClientEmployeeId: CLIENT_EMPLOYEE_ID,
            ClientJobActivityId: 0,
            clockInLatitude: 0, clockOutLatitude: 0,
            clockInLongitude: 0, clockOutLongitude: 0,
            IsJobUDField: true,
            IsEmployeeUDField: false,
            IsActivityUDField: false,
            Mileage: 0,
            MileageUnit: "km",
          });
        }

        job.clientJobActivitiesList?.forEach(act => {
          let hasAct = false;
          actSet.forEach(a => { if(a.jobId === job.clientJobId && a.actId === act.id) hasAct = true; });
          if (hasAct) {
             timeSheetJobList.push({
              Id: 0,
              Notes: "",
              Deleted: false,
              clockInTime: "00:00:00",
              clockOutTime: "00:00:00",
              ClientJobId: job.clientJobId,
              ClientEmployeeId: CLIENT_EMPLOYEE_ID,
              ClientJobActivityId: act.id,
              clockInLatitude: 0, clockOutLatitude: 0,
              clockInLongitude: 0, clockOutLongitude: 0,
              IsJobUDField: true,
              IsEmployeeUDField: false,
              IsActivityUDField: true,
              Mileage: 0,
              MileageUnit: "km",
            });
          }
        });
      });

      if (timeSheetJobList.length === 0) {
        setView(VIEWS.LISTING);
        return;
      }

      const obj = {
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: currentTimeSheetId,
            DateSubmitted: new Date(),
            Date: new Date(),
            TypeId: 3,
            StatusId: TIMESHEET_STATUS.IN_PROGRESS,
            ClientId: CLIENT_ID,
            Deleted: false,
            timeSheetJobList,
          },
        ],
      };

      const res = await Postrequestcall(SAVE_CLIENT_TIMESHEETS_NEW, obj, TOKEN);
      if (res.status === 201) {
        currentTimeSheetId = res.data.data[0].objData.ClientTimesheetId;
        setTimesheetID(currentTimeSheetId);

        // Fetch and save UD Fields
        const resData = res.data.data[0].objData.ClientTimesheetJobs || [];
        const jobIdsToFetch = [...new Set(timeSheetJobList.map(j => j.ClientJobId))].filter(Boolean).join(",");
        const actIdsToFetch = [...new Set(timeSheetJobList.map(j => j.ClientJobActivityId))].filter(Boolean).join(",");

        if (jobIdsToFetch || actIdsToFetch) {
          try {
            const udPayload = { ClientId: CLIENT_ID, JobList: jobIdsToFetch, EmployeeList: "", ActivityList: actIdsToFetch };
            const udRes = await Postrequestcall(FETCH_CLIENT_TIMESHEET_UD_FIELDS_NEW, udPayload, TOKEN);
            const jobUdFields = udRes?.data?.data?.jobUdFields || [];
            const actUdFields = udRes?.data?.data?.activityUdFields || [];
            let udSaveList = [];
            
            timeSheetJobList.forEach(item => {
              const activityId = item.ClientJobActivityId || 0;
              const specificID = resData.find(r =>
                activityId !== 0
                  ? r.ClientJobActivityId == activityId && r.ClientJobId === item.ClientJobId
                  : r.ClientJobActivityId == 0 && r.ClientJobId === item.ClientJobId
              );

              if (!specificID) return;

              jobUdFields.filter(f => f.entityRecordId === 0 || f.entityRecordId === item.ClientJobId).forEach(field => {
                let valStr = field.fieldDefaultValue !== undefined ? field.fieldDefaultValue.toString() : "";
                udSaveList.push({
                  Id: 0, ClientId: CLIENT_ID, ClientEmployeeId: CLIENT_EMPLOYEE_ID, AppId: 11,
                  AppRecordId: currentTimeSheetId, AssociatedRecordId: specificID.ClientTimesheetJobId, AppEntityId: field.appEntityId || 1,
                  EntityRecordId: item.ClientJobId, UDFieldId: field.id, Value: valStr, ModifiedBy: USER_ID
                });
              });

              if (activityId !== 0) {
                actUdFields.filter(f => f.entityRecordId === 0 || f.entityRecordId === activityId).forEach(field => {
                  let valStr = field.fieldDefaultValue !== undefined ? field.fieldDefaultValue.toString() : "";
                  udSaveList.push({
                    Id: 0, ClientId: CLIENT_ID, ClientEmployeeId: CLIENT_EMPLOYEE_ID, AppId: 11,
                    AppRecordId: currentTimeSheetId, AssociatedRecordId: specificID.ClientTimesheetJobActivityId || 0, AppEntityId: field.appEntityId || 3,
                    EntityRecordId: activityId, UDFieldId: field.id, Value: valStr, ModifiedBy: USER_ID
                  });
                });
              }
            });

            if (udSaveList.length > 0) {
              await Postrequestcall(SAVE_CLIENT_UD_FIELDS_VALUES, { UserId: USER_ID, ReturnRecordId: true, ReturnRecordError: true, SaveList: udSaveList }, TOKEN);
            }
          } catch (err) {
            console.error("formatData-> Error processing UD fields:", err);
          }
        }
        
        selectionStore.resetPending();
      }
      setView(VIEWS.LISTING);
    } catch (error) {
      console.log('formatData-> Error: ', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <DeletConfirmModal
        isOpen={confirmModal}
        loading={deleteLoading}
        onConfirm={handelJobDelete}
        title={TEXT_CANNOT_BE_UNDONE}
        heading={TEXT_DELETE_HEADER}
        onClose={() => { setConfirmModal(false); setCurrentDeleteid(null); setDeleteDataObj(null); }}
      />
      {isLoading ? (
        <TimesheetSkeletonLoader variant="selectJob" />
      ) : (
        <Grid container spacing={1}>
          <Grid size={12}>
            <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
              <Typography>{TEXT_SELECT_JOB_ACTIVITIES}</Typography>
              <Stack direction="row" sx={{ cursor: "pointer", gap: 0.5, alignItems: "center" }} onClick={() => setSortByNearby((prev) => !prev)}>
                <Typography>{TEXT_SORT_BY} </Typography>
                <Typography sx={{ color: CLIENT_COLOR }}>{sortByNearby ? TEXT_NEAR_BY : TEXT_RECENT}</Typography>
              </Stack>
            </Stack>
          </Grid>
          <Grid sx={{ maxHeight: "300px", overflow: "auto" }} size={12}>
            <Stack spacing={1}>
              {jobs?.length === 0 && (
                <Stack sx={{ justifyContent: "center", alignItems: "center", height: "100px", width: "100%" }}>
                  <Typography color={BIGrey}>{TEXT_NO_JOBS_FOUND}</Typography>
                </Stack>
              )}
              {jobs.map((job) => (
                <Listing
                  key={job.clientJobId}
                  job={job}
                  CLIENT_COLOR={CLIENT_COLOR}
                  handelJobClick={handelJobClick}
                  handelActivityClick={handelActivityClick}
                />
              ))}
            </Stack>
          </Grid>
          <Grid size={12}>
            <LoadingButton
              disabled={!hasAnySelection}
              onClick={formatData}
              loadingPosition="start"
              startIcon={<></>}
              loading={loading}
              fullWidth
              sx={{ bgcolor: !hasAnySelection || loading ? "#e4e4e4" : CLIENT_COLOR, color: "white", textTransform: "none" }}>
              {BUTTON_NEXT}
            </LoadingButton>
          </Grid>
        </Grid>
      )}
    </>
  );
}

const Listing = memo(({ job, CLIENT_COLOR, handelJobClick, handelActivityClick }) => {
  const hasActivities = job.clientJobActivitiesList?.length > 0;
  
  const jobKey = `J:${job.clientJobId}`;
  const jobMode = useSelectionMode(jobKey);
  const isJobSelected = jobMode === 'committed' || jobMode === 'pending';

  return (
    <>
      {!hasActivities ? (
        <Stack
          onClick={() => handelJobClick(job)}
          direction="row"
          sx={{ cursor: "pointer", border: "1px solid #f0f0f0", borderRadius: "5px", gap: 1, alignItems: "center" }}>
          <Checkbox checked={isJobSelected} sx={{ "&.Mui-checked": { color: CLIENT_COLOR } }} />
          <Typography sx={{ fontWeight: "bold" }}>{job.clientJobCode} - {job.clientJobName}</Typography>
        </Stack>
      ) : (
        <Stack sx={{ padding: "10px", borderRadius: "5px", gap: 1 }}>
          <Typography sx={{ fontWeight: "bold" }}>{job.clientJobCode} - {job.clientJobName}</Typography>
          <Stack sx={{ paddingLeft: "10px", gap: 1 }}>
            {job.clientJobActivitiesList?.map((act) => {
              const actKey = `A:${job.clientJobId}:${act.id}`;
              const altKey = `A:${act.id}`;
              const actMode = useSelectionMode(actKey, altKey);
              const isActSelected = actMode === 'committed' || actMode === 'pending';
              
              return (
                <Stack
                  key={act.id}
                  onClick={() => handelActivityClick(job, act)}
                  direction="row"
                  sx={{ border: "1px solid #f0f0f0", borderRadius: "5px", cursor: "pointer", gap: 1, alignItems: "center" }}>
                  <Checkbox checked={isActSelected} sx={{ "&.Mui-checked": { color: CLIENT_COLOR } }} />
                  <Typography sx={{ fontWeight: "bold" }}>{act.labourActivityCode} - {act.labourActivityName}</Typography>
                </Stack>
              );
            })}
          </Stack>
        </Stack>
      )}
    </>
  );
});

export default SelectJobModal;
